// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.citySelectorWrap {
  position: relative;
}
.citySelectorWrap .cityDropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  width: 100%;
  max-height: 14rem;
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #eee;
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  z-index: 50;
}
.citySelectorWrap .cityDropdown::-webkit-scrollbar {
  width: 5px;
}
.citySelectorWrap .cityDropdown::-webkit-scrollbar-thumb {
  background-color: rgba(81, 85, 146, 0.25);
  border-radius: 10px;
}
.citySelectorWrap .cityDropdown .searchWrapper {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.5rem 0.5rem 0.4rem;
  background-color: #ffffff;
}
.citySelectorWrap .cityDropdown .searchWrapper input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0.75rem;
  font-size: 0.82rem;
  background-color: #f9f9f9;
  border: 1.5px solid #eee;
  border-radius: 0.6rem;
  transition: all 0.2s ease;
}
.citySelectorWrap .cityDropdown .searchWrapper input:focus {
  outline: none;
  border-color: #515592;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(81, 85, 146, 0.1);
}
.citySelectorWrap .cityDropdown .listContainer {
  padding: 0 0.4rem 0.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}
.citySelectorWrap .cityDropdown .listContainer .listItem {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.42rem 0.6rem;
  font-size: 0.82rem;
  font-weight: 500;
  color: #333;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.citySelectorWrap .cityDropdown .listContainer .listItem svg {
  flex-shrink: 0;
  color: #ccc;
  transition: color 0.15s ease;
}
.citySelectorWrap .cityDropdown .listContainer .listItem:hover {
  background-color: rgba(81, 85, 146, 0.08);
  color: #515592;
}
.citySelectorWrap .cityDropdown .listContainer .listItem:hover svg {
  color: #515592;
}
.citySelectorWrap .cityDropdown .listContainer .listItem:active {
  background-color: rgba(81, 85, 146, 0.14);
}
.citySelectorWrap .cityDropdown .listContainer .listItem span.highlight {
  background-color: rgba(81, 85, 146, 0.15);
  color: #515592;
  font-weight: 700;
  border-radius: 0.2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/CitySelector/CitySelector.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;AAHF;AAKE;EACE,kBAAA;EACA,wBAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBCdI;EDeJ,sBAAA;EACA,mBAAA;EACA,2CAAA;EACA,WAAA;AAHJ;AAKI;EACE,UAAA;AAHN;AAMI;EACE,yCAAA;EACA,mBAAA;AAJN;AAOI;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,6BAAA;EACA,yBClCE;AD6BR;AAOM;EACE,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yBAAA;AALR;AAOQ;EACE,aAAA;EACA,qBA9CM;EA+CN,yBCjDF;EDkDE,4CAAA;AALV;AAUI;EACE,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AARN;AAUM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,yDAAA;AARR;AAUQ;EACE,cAAA;EACA,WAAA;EACA,4BAAA;AARV;AAWQ;EACE,yCAAA;EACA,cA/EM;AAsEhB;AAWU;EACE,cAlFI;AAyEhB;AAaQ;EACE,yCAAA;AAXV;AAcQ;EACE,yCAAA;EACA,cA5FM;EA6FN,gBAAA;EACA,qBAAA;AAZV","sourcesContent":["@import '../../assets/Theme/variables/colorSchema';\n\n$brand_primary: #515592;\n\n.citySelectorWrap {\n  position: relative;\n\n  .cityDropdown {\n    position: absolute;\n    top: calc(100% + 0.5rem);\n    left: 0;\n    width: 100%;\n    max-height: 14rem;\n    overflow-y: auto;\n    background-color: $white;\n    border: 1px solid #eee;\n    border-radius: 1rem;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n    z-index: 50;\n\n    &::-webkit-scrollbar {\n      width: 5px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: rgba($brand_primary, 0.25);\n      border-radius: 10px;\n    }\n\n    .searchWrapper {\n      position: sticky;\n      top: 0;\n      z-index: 1;\n      padding: 0.5rem 0.5rem 0.4rem;\n      background-color: $white;\n\n      input {\n        width: 100%;\n        box-sizing: border-box;\n        padding: 0.5rem 0.75rem;\n        font-size: 0.82rem;\n        background-color: #f9f9f9;\n        border: 1.5px solid #eee;\n        border-radius: 0.6rem;\n        transition: all 0.2s ease;\n\n        &:focus {\n          outline: none;\n          border-color: $brand_primary;\n          background-color: $white;\n          box-shadow: 0 0 0 3px rgba($brand_primary, 0.1);\n        }\n      }\n    }\n\n    .listContainer {\n      padding: 0 0.4rem 0.4rem;\n      display: flex;\n      flex-direction: column;\n      gap: 0.15rem;\n\n      .listItem {\n        display: flex;\n        align-items: center;\n        gap: 0.4rem;\n        padding: 0.42rem 0.6rem;\n        font-size: 0.82rem;\n        font-weight: 500;\n        color: #333;\n        border-radius: 0.5rem;\n        cursor: pointer;\n        transition: background-color 0.15s ease, color 0.15s ease;\n\n        svg {\n          flex-shrink: 0;\n          color: #ccc;\n          transition: color 0.15s ease;\n        }\n\n        &:hover {\n          background-color: rgba($brand_primary, 0.08);\n          color: $brand_primary;\n\n          svg {\n            color: $brand_primary;\n          }\n        }\n\n        &:active {\n          background-color: rgba($brand_primary, 0.14);\n        }\n\n        span.highlight {\n          background-color: rgba($brand_primary, 0.15);\n          color: $brand_primary;\n          font-weight: 700;\n          border-radius: 0.2rem;\n        }\n      }\n    }\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
